import { render, staticRenderFns } from "./PreparationOrderCard.vue?vue&type=template&id=0871dd6c&scoped=true&"
import script from "./PreparationOrderCard.vue?vue&type=script&lang=js&"
export * from "./PreparationOrderCard.vue?vue&type=script&lang=js&"
import style0 from "./PreparationOrderCard.vue?vue&type=style&index=0&id=0871dd6c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0871dd6c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/echope/echope-front/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0871dd6c')) {
      api.createRecord('0871dd6c', component.options)
    } else {
      api.reload('0871dd6c', component.options)
    }
    module.hot.accept("./PreparationOrderCard.vue?vue&type=template&id=0871dd6c&scoped=true&", function () {
      api.rerender('0871dd6c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/pages/sale/preparation-dashboard/components/PreparationOrderCard.vue"
export default component.exports